var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.884 15.12-3.052-3.025c2.276-2.638 2.146-6.62-.362-9.13A6.614 6.614 0 0 0 7.737 1c-1.707 0-3.44.647-4.759 1.966a6.712 6.712 0 0 0 0 9.517 6.737 6.737 0 0 0 4.76 1.965 6.65 6.65 0 0 0 4.37-1.629l3.051 3.052c.078.077.207.129.337.129a.51.51 0 0 0 .362-.155c.207-.181.207-.517.026-.724ZM3.703 11.734c-1.087-1.06-1.656-2.509-1.656-4.009 0-1.5.595-2.948 1.656-4.034C4.789 2.603 6.21 2.034 7.737 2.034c1.526 0 2.948.595 4.035 1.656a5.738 5.738 0 0 1 1.655 4.034 5.738 5.738 0 0 1-1.655 4.035 5.783 5.783 0 0 1-4.035 1.655c-1.5 0-2.948-.595-4.034-1.681Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.5800d581c58226db99ab99d7f30fd0b0.svg";
export { ForwardRef as ReactComponent };